import HttpClient from "./http-client";
import ITronLogo, { ITronLogoEventData } from "./tron-logo";
import { getApiUrl } from "./common";

export class FileUploader {
    private fileInput: Element;
    private url: string;
    private onSuccess: () => void;

    constructor(fileInput: Element, url: string, onSuccess: () => void = null) {
        this.fileInput = fileInput;
        this.url = url;
        this.onSuccess = onSuccess;
        this.init();
    }

    private async upload(event: Event): Promise<void> {
        const target = event.target as HTMLInputElement;
        const files = target.files;
        const formData = new FormData();
        formData.append('file', files[0]);

        const response = await new HttpClient().fetch(this.url, {
            method: 'POST',
            body: formData
        });

        if(response.ok) {
            this.onSuccess && this.onSuccess();
        }
    }

    private init(): void {
        this.fileInput.addEventListener(
            'change',
            async event => await this.upload(event)
        );
    }
}

export class TronLogoFileUploader {
    private tronLogoInitAttemptCount = 0; 
    private onSuccess: () => void;
    
    constructor(onSuccess: () => void){
        this.onSuccess = onSuccess;
        this.init();
    }

    private init(){
        this.addTronLogoListener();
    }

    private addTronLogoListener = () => {
        const tronLogo = window.tronlogo as ITronLogo
        if (tronLogo) {
            // Pass the bound handler directly (it is an arrow field, so `this` is the instance no matter
            // who invokes it from the TL engine).
            tronLogo.registerForTronLogoEvents(this.tronLogoEventHandler);
            return;
        }
        this.tronLogoInitAttemptCount += 1;
        if (this.tronLogoInitAttemptCount < 10) {
            // Arrow function + setTimeout(fn) — keep `this` bound; the TL engine is loaded via
            // <script async> so it is frequently not ready on the first synchronous attempt and we
            // must retry. (A plain method reference here would fire with the wrong `this`.)
            window.setTimeout(this.addTronLogoListener, 200);
        }
    }

    private tronLogoEventHandler = async (eventData: ITronLogoEventData): Promise<void> => {
        if(eventData.type === 'UPLOADDONE' || eventData.type == 'MOTIVECHANGE'){
            console.log(`Tron Logo upload done. Image guid: ${eventData.motiveId}, cart item id: ${eventData.custom1}`);
            // The TL user guid is only knowable while the TL engine is loaded — which it provably is
            // right now (this event came from it). Sent along so the server can persist a direct logo
            // image URL for the cart thumbnail; resolving it later at render time is impossible on
            // pages where the TL engine never loads.
            const tlUserGuid = (window as any).tron?.User?.userGuid as string | undefined;
            const query = tlUserGuid ? `?tlUserGuid=${encodeURIComponent(tlUserGuid)}` : '';
            const url = `${getApiUrl()}/cart/${eventData.custom1}/file/tronlogo/${eventData.motiveId}${query}`;

            const response = await new HttpClient().fetch(url, {
                method: 'POST'
            });

            response.ok && this.onSuccess && this.onSuccess();
        }
    }

}
